import React, {createContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {User} from "../../../services/users.services";
import {getCookie} from "../../../services/connectors/cookies";
import {useAlert} from "../Alert/Alert.provider";
import {getLoggedUserId} from "../../../services/auth.services";

export const useAuthContext = createContext({
  loggedUser: null as unknown as User,
  setLoggedUser: (user: User) => {
  }
});

export function AuthProvider(props: { children?: React.ReactNode }) {
  const [loggedUser, setLoggedUser] = useState<User>(null)
  const loginValue = {loggedUser, setLoggedUser}

  return (
    <useAuthContext.Provider value={loginValue}>
      {props.children}
    </useAuthContext.Provider>
  );
}

export const useAuth = () => {
  return React.useContext(useAuthContext);
}

export const RequireAuth = ({children}: { children: JSX.Element }) => {
  const navigate = useNavigate();
  const alerter = useAlert();
  const auth = useAuth()

  useEffect(() => {
    if (!getCookie('token')) {
      navigate('/');
    }
    try {
      const token = getCookie('token')
      if (!token) {
        throw "No token"
      }
      getLoggedUserId()
        .then((userId) => {
          if (userId){
            auth.setLoggedUser({
              id: userId
            })
          }
        })
    } catch (e) {
      alerter.setAlertEvent({
        message: e.message || 'An error occurred while checking authentication.',
        severity: "error"
      })
    }
  }, [])

  return children;
}